import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NSBanner, NSButton, NSColumn, NSLoading, NSRow, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { OfferFullRow, SubscriptionRow } from 'namirasoft-payment';
import { PaymentLayout } from "../PaymentLayout";
import { PaymentProps } from "../PaymentProps";
import { PaymentRoutes } from '../PaymentRoutes';
import NSPOfferCard from '../components/NSPOfferCard';

export interface SubscriptionCancellationOfferPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface SubscriptionCancellationOfferPageState
{
	offer: OfferFullRow | null;
	subscription: SubscriptionRow | null;
}

function SubscriptionCancellationOfferPage(props: SubscriptionCancellationOfferPageProps)
{
	let { id, offer_id, cancellation_reason_id } = useParams();
	let cancellation_explaination = props.url.getQuery("cancellation_explaination");

	let [state, setState] = useState<SubscriptionCancellationOfferPageState>({
		offer: null,
		subscription: null,
	});

	useEffect(() =>
	{
		if (offer_id)
			loadOffer(offer_id);
		// eslint-disable-next-line
	}, []);

	function loadOffer(offer_id: string)
	{
		if (offer_id)
			props.servers.payment.offer.Get(offer_id)
				.then((res) => setState(prevState => ({ ...prevState, subscription: res.subscription, offer: res })))
				.catch(() => { });
		else if (id && cancellation_reason_id)
			props.url.redirect(PaymentRoutes.SubscriptionCancellationConfirmation(id, cancellation_reason_id, true, ""), { cancellation_explaination });
	}

	return (
		<PaymentLayout {...props}
			action={{
				title: `Cancellation Offer`,
				description: "",
				menus: {}
			}}
		>
			{
				state.offer ?
					<NSSection >
						<NSColumn>
							<NSRow>
								<NSBanner
									imageLeft={{
										src: "https://static.namirasoft.com/image/concept/bot/happy.png",
										alt: "happy bot"
									}}
									imageRight={null}
									headline={{ text: "Wait! Before You Go ..." }}
									title={{
										text: "We Have an Offer for You!",
										style: { color: "green" }
									}}
								/>
							</NSRow>
						</NSColumn>
						{
							<NSColumn>
								<NSRow>
									<NSSpace size={NSSpaceSizeType.SMALL} />
									<NSPOfferCard
										key={state.offer.id}
										{...props}
										offer={state.offer}
										offer_items={state.offer.offer_item}
										subscription={state.offer.subscription}
										button={{
											text: "Accept the Offer & Apply"
										}}
									/>
								</NSRow>
							</NSColumn>
						}

						<NSColumn>
							<NSRow>
								<NSSpace size={NSSpaceSizeType.XLARGE} />
								<NSButton
									title='Continue with the Cancellation'
									onClick={{
										action: () =>
										{
											if (id && cancellation_reason_id)
												props.url.redirect(PaymentRoutes.SubscriptionCancellationConfirmation(id, cancellation_reason_id, true, ""), { cancellation_explaination });
										},
										showLoading: false
									}}
									style={{
										backgroundColor: "gray",
										color: "white",
										border: "none"
									}} />
							</NSRow>
						</NSColumn>
					</NSSection>
					:
					<NSLoading />
			}
		</PaymentLayout >
	);
}

export default SubscriptionCancellationOfferPage;